import '.fi{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.fj{padding-left:1.5rem;}.ssr-plugin'
import '.fk{margin:1rem 0;}.ssr-plugin'
import '.fl{color:var(--gray-700);}.ssr-plugin'
import '.fm{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="fi fj fk fl fm"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
